import React from "react";

import "./AboutUs.css";

export default () => {
  return (
    <div className="about-us">
      <div className="about-us-caption">
        <h1>SOBRE A INSTITUIÇÃO</h1>
        <p>
          Se você, ou alguém que você conhece, possui deficiência visual, é
          possível que exista um problema muito maior. O Centro de Pesquisa e
          Reabilitação Visual de Itapetininga adota uma abordagem holística e
          trata o todo, não apenas a deficiência. Utilizamos diversos
          tratamentos para ajudar pessoas a superar sua deficiência em
          Itapetininga e região desde 02/04/2003. Nunca é tarde demais para nos
          procurar e pedir ajuda.
        </p>
      </div>
    </div>
  );
};
